// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".name[data-v-74a19ac4] {\n  font-size: 15px;\n  margin-bottom: 16px;\n  line-height: 1.4;\n}\n.name.required[data-v-74a19ac4]:after {\n    content: \"*\";\n    color: red;\n}\n.variant[data-v-74a19ac4]:not(:last-child) {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
